import { render, staticRenderFns } from "./MaterialListTab.vue?vue&type=template&id=4eb5aa5e&scoped=true&"
import script from "./MaterialListTab.vue?vue&type=script&lang=ts&"
export * from "./MaterialListTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb5aa5e",
  null
  
)

export default component.exports